import { api } from "./api"

export const GET_ALL_STRIPES = async () => {
    const { data } = await api.get(`/stripes`)
    return data.stripes || [];
}

export const CONNECT_STRIPE = async (params: any) => {
    const { data } = await api.post(`/stripes`, params)
    return data;
}

export const SET_STRIPE_CONNECTED = async (stripeId: string) => {
    const { data } = await api.patch(`/stripes/${stripeId}/connected`)
    return data;
}

export const SESSION_STRIPE = async (params: any) => {
    const { data } = await api.post(`/stripes/session`, params)
    return data;
}
